import { Card, CardContent, CardHeader, Grid } from "@mui/material"
import InfoBox from "../../../../common/InfoBox"
import AreaChart from "../../../../components/charts/AreaChart"
import { formatNumber, numberPrecision } from "../../../../helpers/UtilityHelper"
import { SERIES_COLORS } from "../../../charts/colors"

const chartOptions = {
    xaxis: 'name',
    showLabels: true,
    legendAlign: 'left',
    yLabel: '# Shipments',
    data: [
        {
            dataKey: 'totalCount',
            label: 'Number of Shipments',
            fill: SERIES_COLORS[0],
        },
    ],
}

export default function ShipmentsOverview({ data }) {
    return (
        <Card elevation={0}>
            <CardHeader title="Shipments Overview" />
            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={6} sm={4} md>
                        <InfoBox header="Total Forward Shipments" value={formatNumber(data.awbRegisteredOrderCount)} />
                    </Grid>
                    <Grid item xs={6} sm={4} md>
                        <InfoBox header="Picked Shipments" value={formatNumber(data.pickedUpOrderCount)} />
                    </Grid>
                    <Grid item xs={6} sm={4} md>
                        <InfoBox header="Pending Pickup Shipments" value={formatNumber(data.awbRegisteredOrderCount - data.pickedUpOrderCount - (data.cancelledOrderCount || 0))} />
                    </Grid>
                    <Grid item xs={6} sm={4} md>
                        <InfoBox header="Cancelled Shipments" value={formatNumber(data.cancelledOrderCount || 0)} />
                    </Grid>
                    <Grid item xs={6} sm={4} md>
                        <InfoBox header="Prepaid / COD %" value={numberPrecision(data.prepaidPercentage) + " / " + numberPrecision(data.codPercentage)} />
                    </Grid>
                    <Grid item xs={12} sx={{ mt: 2 }}>
                        <AreaChart data={data.lineChartData} chartOptions={chartOptions} />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}
